import { resourceReducer, getResources } from 'redux-resource';

export default resourceReducer('paymentMethods');

export const getDefaultPaymentMethod = (state) => {
  const primary = getResources(state, (pm) => {
    return pm.is_default;
  });
  if (primary && primary.length > 0) {
    return primary[0];
  }
  else {
    return null;
  }
}
export const getAllPaymentMethods = (state) => getResources(state);
export const getDeletePaymentMethodStatus = (state, id) => state.meta[id] && state.meta[id].deleteStatus;
